import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Lightbulb, ArrowRight } from "lucide-react";

export default function FixSuggestions({ suggestions }) {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <Card className="border border-border shadow-none" data-testid="fix-suggestions-panel">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-bold flex items-center gap-2">
          <Lightbulb className="w-5 h-5 text-yellow-500" />
          Suggested Fixes
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {suggestions.map((suggestion, idx) => (
            <div key={idx} className="fix-suggestion" data-testid={`fix-suggestion-${idx}`}>
              <ArrowRight className="fix-suggestion-icon text-blue-500 mt-0.5" />
              <p className="text-sm">{suggestion}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
